type ImageType = 'provider' | 'others';

type ImageFallback = {
  type: ImageType;
  name: string;
};

function getValueAsString(value: unknown): string | undefined {
  if (typeof value === 'string') {
    const normalized = value.trim();
    return normalized || undefined;
  }

  if (typeof value === 'number') {
    return String(value);
  }

  return;
}

function normalizeProvider(
  provider: unknown,
): 'aws' | 'azure' | 'gcp' | 'kubernetes' | undefined {
  const normalized = getValueAsString(provider)?.toLowerCase();

  if (!normalized) {
    return;
  }

  if (normalized.includes('aws') || normalized.includes('amazon')) {
    return 'aws';
  }

  if (normalized.includes('azure')) {
    return 'azure';
  }

  if (normalized.includes('gcp') || normalized.includes('google')) {
    return 'gcp';
  }

  if (normalized.includes('k8s') || normalized.includes('kubernetes')) {
    return 'kubernetes';
  }

  return;
}

function getResourceTypeProvider(resourceType: unknown): string | undefined {
  const normalized = getValueAsString(resourceType);

  if (!normalized) {
    return;
  }

  const byDoubleColon = normalized.split('::')[0];

  if (byDoubleColon && byDoubleColon !== normalized) {
    return byDoubleColon;
  }

  return normalized.split(':')[0];
}

export function getResourceImageFallback({
  provider,
  resourceType,
}: {
  provider?: unknown;
  resourceType?: unknown;
}): ImageFallback {
  const normalizedProvider =
    normalizeProvider(provider) ??
    normalizeProvider(getResourceTypeProvider(resourceType));

  if (normalizedProvider) {
    return {
      type: 'provider',
      name: normalizedProvider,
    };
  }

  return {
    type: 'others',
    name: 'globe',
  };
}
